import { TextField } from '@mui/material';

const ColorPicker = ({ color, setColor }: {
    color: string;
    setColor: (color: string) => void;
}) => {
    return (
        <TextField
            type="color"
            defaultValue={color}
            onBlur={(event) => {
                setColor(event.target.value);
            }}
            variant="outlined"
            sx={{
                width: 42,
                height: 42,
                mr: 2,
                p: 0,
                '& .MuiInputBase-root': {
                    p: 0,
                    height: '100%',
                    borderRadius: '4px',
                },
                '& fieldset': { display: 'none' },

                '& input[type=\'color\']': {
                    cursor: 'pointer',
                    padding: 0,
                    border: 'none',
                    width: '100%',
                    height: '100%',
                    background: 'none',
                    borderRadius: '4px',
                    WebkitAppearance: 'none',
                },

                '& input[type=\'color\']::-webkit-color-swatch-wrapper': {
                    padding: 0,
                    borderRadius: '4px',
                },
                '& input[type=\'color\']::-webkit-color-swatch': {
                    border: '1px solid rgba(0,0,0,0.4)',
                    borderRadius: '4px',
                },
            }}
        />
    );
};

export default ColorPicker;
